import { useState } from "react";
import { taceimgs, taceimgst } from "../data/galleryimgdata";

const TacExperience = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openImage = (index) => {
    setCurrentIndex(index);
    setSelectedImage(taceimgs[index].image);
  };

  const closeImage = () => {
    setSelectedImage(null);
  };

  const prevImage = () => {
    const newIndex = (currentIndex - 1 + taceimgs.length) % taceimgs.length;
    setCurrentIndex(newIndex);
    setSelectedImage(taceimgs[newIndex].image);
  };

  const nextImage = () => {
    const newIndex = (currentIndex + 1) % taceimgs.length;
    setCurrentIndex(newIndex);
    setSelectedImage(taceimgs[newIndex].image);
  };

  return (
    <>
      <h1>The Afro collective experience</h1>
      <div className="gallery-images-container">
        {taceimgs.map((row, rowIndex) => (
          <div key={rowIndex} className={`image-row-${rowIndex}`}>
            {row.map((img, index) => (
              <img
                loading="lazy"
                key={index}
                src={img}
                alt={`${index + 1}`}
                onClick={() => openImage(index)}
                style={{ cursor: "pointer" }} />
            ))}
          </div>
        ))}
      </div>

      <div className="tace-img-containert">
        {taceimgst.map((row, rowIndex) => (
          <div key={rowIndex} className={`imaget-row-${rowIndex}`}>
            {row.map((img, index) => (
              <img
                key={index}
                src={img}
                alt={`${index + 1}`}
                onClick={() => openImage(index)}
                style={{ cursor: "pointer" }} />
            ))}
          </div>
        ))}
      </div>
      {selectedImage && (
        <div className="modal">
          <span className="close" onClick={closeImage}>&times;</span>
          <button className="prev" onClick={prevImage}>&#10094;</button>
          <img src={selectedImage} alt="Selected" className="modal-content" />
          <button className="next" onClick={nextImage}>&#10095;</button>
        </div>
      )}
    </>
  );
};

export default TacExperience;
